import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { BaseURL, PageBanner } from "../APIs/APIUrls";

const allowedRoutes = [  
  
  
  /^\/property-details\/[^/]+$/,
  /^\/contact-us$/,
  /^\/privacy-policy$/,
  /^\/about-us$/,
  /^\/our-services$/,
  /^\/author\/[^/]+$/,
  /^\/blog-grid$/,
  /^\/blog-detail\/[^/]+$/,
];

const Webpage = () => {
  const { pathname } = useLocation();
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  const shouldRenderSchema = allowedRoutes.some((pattern) =>
    pattern.test(pathname),
  );

  useEffect(() => {
    const fetchPageBannerData = async () => {
      try {
        // Check localStorage first
        const cachedData = localStorage.getItem("pageBannerData");
        let data;

        if (cachedData) {
          data = JSON.parse(cachedData);
        } else {
          // Fetch from API if not in cache
          const response = await fetch(`${PageBanner}GetAllPageBannerforWeb`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          });

          if (response.ok) {
            const result = await response.json();
            if (result.isSuccess && result.data) {
              data = result.data;
              // Store in localStorage
              localStorage.setItem("pageBannerData", JSON.stringify(data));
            }
          }
        }

        setPageData(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching page banner data:", error);
        setLoading(false);
      }
    };

    fetchPageBannerData();
  }, []);

  if (!shouldRenderSchema || pathname === "/404" || loading) {
    return null;
  }

  const websiteName = "https://askmerealty.in/";
  const webUrl = `${websiteName}${pathname}`;
  const currentPath = pathname === "/" || pathname === "" ? "/home" : pathname;

  // Match current pathname with PageURL from API response
  let matchedPageData = null;
  if (pageData && Array.isArray(pageData)) {
    matchedPageData = pageData.find((page) => {
      const pageUrlPath = page.PageURL
        ? `/${page.PageURL.replace(/^\/+/, "")}`
        : null;
      return (
        pageUrlPath === currentPath ||
        pageUrlPath === `${currentPath}/` ||
        pageUrlPath === pathname ||
        pageUrlPath === `${pathname}/`
      );
    });
  }

  // Use matched page data or fallback to defaults
  const metaTitle =
    matchedPageData?.MetaTitle ||
    "Home - AskMe Realty | Trusted Real Estate Portal India";
  const metaDescription =
    matchedPageData?.MetaDescription ||
    "Find your dream home with AskMe Realty. Buy, sell, or rent properties in Delhi NCR. Verified listings, expert consultation, and site visit assistance.";
  const primaryImage =
    matchedPageData?.Image ||
    "https://askmerealty.in/images/homepage-banner.jpg";

  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: metaTitle,
    description: metaDescription,
    url: webUrl,
    inLanguage: "en-IN",
    isPartOf: {
      "@type": "WebSite",
      name: "AskMe Realty",
      url: `${webUrl}/`,
    },
    primaryImageOfPage: BaseURL + primaryImage,
    about: {
      "@type": "RealEstateAgent",
      name: "AskMe Realty",
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

export default Webpage;
